<template>
  <div v-if="is_known" class="availability-toggle">
    <vb-checkbox
      :vb_options="{
        switch: true,
        text: 'Mostra in base al credito',
        value: active,
        checked: active,
      }"
      @change="(value) => $emit('toggle', value)"
    />
  </div>
</template>

<script>
  export default {
    name: 'availability-toggle',

    props: {
      active: {
        type: Boolean,
        default: false,
      },
      is_known: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .availability-toggle {
    display: block;

    ::v-deep .vb-check__title {
      font-size: $font-size-md;
    }
  }
</style>
